import axios from "../utils/request";

// 获取课程

export function getCourseInfo(params) {
  return axios({
    url: "/wxpubapp/class/getCourseInfo",
    method: "get",
    params,
  });
}
// 获取活动
export function getActivityInfo(params) {
  return axios({
    url: "/wxpubapp/activity/getActivityInfo",
    method: "get",
    params,
  });
}
